  <!-- HEADER -->
  <div style="float:left;">
    <h2 mat-dialog-title><span translate>{{report.Description}}</span></h2>
  </div>
  <!-- CONTENT -->
  <mat-dialog-content>
    <table style="width:100%;" st-select-row="parameterRow" st-select-mode="single">
      <tr>
        <td>
          <div>
            <table>
              <tr>
                <td colspan="3" style="padding-top:5px;">
                  <tyl-form-field label="Report Title" style="width:350px;">
                    <input matInput name="ReportTitle" id="ReportTitle" [(ngModel)]="reportParameter.ReportTitle" />
                  </tyl-form-field>
                </td>
                <td style="padding-left:10px; width:300px;" rowspan="4">
                  <table>
                    <tr>
                      <td>
                        <tyl-checkbox [(checked)]="reportParameter.PrintStudentAbsencesAlreadyEntered"
                          id="chkPrintStudentAbsencesAlreadyEntered" name="chkPrintStudentAbsencesAlreadyEntered">
                          Print Student absences already entered
                        </tyl-checkbox>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <tyl-checkbox [(checked)]="reportParameter.PrintTeacherSignatureLine"
                          id="chkPrintTeacherSignatureLine" name="chkPrintTeacherSignatureLine">
                          Teacher signature line
                        </tyl-checkbox>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <tyl-checkbox [(checked)]="reportParameter.PrintWithGreyHeading" id="chkPrintWithGreyHeading"
                          name="chkPrintWithGreyHeading">
                          Print w/Grey
                          Headings
                        </tyl-checkbox>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <tyl-checkbox [(checked)]="reportParameter.SkipLineBetweenStudent" id="chkLineBetweenStudent"
                          name="chkLineBetweenStudent">
                          Skip Line
                          Between Student
                        </tyl-checkbox>
                      </td>
                    </tr>
                  </table>
                </td>

              </tr>
              <tr>
                <td colspan="3"></td>
                <td style="width:150px;" style="padding-left:3px;" rowspan="3">
                  <tyl-radio-group [(selected)]="reportParameter.radValue"
                      [values]="['radNoField', 'radPrintStudentID', 'radOtherField']"
                      [labels]="['Nothing Else', 'Print Student ID', 'Other Field:']"
                      [ids]="['rbNoField', 'rbPrintStudentID','rbOtherField']" arrange='vertical'
                      style='padding-left:10px;'>
                    </tyl-radio-group>
                </td>
              </tr>
              <tr>
                <td style="width:150px;">Display Weeks of:</td>
                <td>
                  <div>
                    <table>
                      <tr>
                        <td style="vertical-align:middle;width:100px;">
                          <tyl-datepicker label="Week 1" name="Week1Date" id="Week1Date" #Week1Date
                            [(value)]="reportParameter.Week1Date" (valueChange)="setReportTitle()">
                          </tyl-datepicker>
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
                <td>
                  <div>
                    <table>
                      <tr>
                        <td style="vertical-align:middle;width:100px;padding-left:10px;">
                          <tyl-datepicker label="Week 2" id="Week2Date" name="Week2Date" #Week2Date
                            [(value)]="reportParameter.Week2Date" (valueChange)="setReportTitle()">
                          </tyl-datepicker>
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
                <td></td>
                <td width="150px;" style="padding-left:3px;vertical-align:bottom">
                  <div>
                    <table>
                      <tr>
                        <td style="vertical-align:bottom;width:100px;">
                          <div style ="margin-top: 80px;">
                          <tyl-form-field label="Other
                                Field" >
                            <mat-select id="OtherField" name="OtherField" [(ngModel)]="reportParameter.OtherField">
                              <mat-option *ngFor="let result of reportParameter.OtherFields | orderBy :'Sequence'"
                                [value]="result.Id">
                                {{result.Code}}
                              </mat-option>
                            </mat-select>
                          </tyl-form-field>
                        </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <table style="border: 1px solid lightgray;margin-top:10px;">
            <tr>
              <td style="padding-left:3px;">
                <div style="padding-top:5px;">
                  <tyl-form-field label="View">
                    <mat-select id="Terms" name="Terms" [(ngModel)]="reportParameter.TermId"
                      (selectionchange)="changeValue()">
                      <mat-option *ngFor="let result of reportParameter.Terms|orderBy: 'LongDescription'"
                        [value]="result.Id">
                        {{result.LongDescription}}
                      </mat-option>
                    </mat-select>
                  </tyl-form-field>
                </div>
              </td>
              <td style="padding-left:3px;">
                <div style="padding-top:5px;">
                  <tyl-form-field label="From Period" style="min-width:100px; max-width:100px">
                    <input matInput #FromPeriod name="FromPeriod" id="FromPeriod"
                      [(ngModel)]="reportParameter.FromPeriod" min='0' [textMask]="numberMask"
                      style="text-align:right;width:100px;" (change)="changeValue()" />
                  </tyl-form-field>
                </div>
              </td>
              <td style="padding-left:15px;">
                <div style="padding-top:5px;">
                  <tyl-form-field label="To Period" style="min-width:100px; max-width:100px">
                    <input matInput name="ToPeriod" #ToPeriod id="ToPeriod" [(ngModel)]="reportParameter.ToPeriod"
                      min='0' [textMask]="numberMask" style="text-align:right;width:100px;" (change)="changeValue()" />
                  </tyl-form-field>
                </div>
              </td>
              <td style="padding-left:10px;padding-right:3px;">
                <button mat-button tyle="color: black;" (click)="refreshGrid()">Update
                  Display
                </button>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <!-- Angular Material table definition -->
    <div style="display: flex;flex-direction: column;"
      [ngStyle]="{'overflow': isDataExist ? 'auto' :'hidden' }">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" style="width:100%;">
        <ng-container matColumnDef="SelectAll">
          <th mat-header-cell *matHeaderCellDef>
            <tyl-checkbox [(checked)]="reportParameter.selectAllReportGridData" id="chkselectAll" name="chkselectAll"
              (change)="selectAll(reportParameter.selectAllReportGridData)">
            </tyl-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <tyl-checkbox [(checked)]="element.Select" #Select (change)="selectClass()" translate>
            </tyl-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="AbbreviatedTitle">
          <th mat-header-cell *matHeaderCellDef> Title </th>
          <td mat-cell *matCellDef="let element">{{element.AbbreviatedTitle}}</td>
        </ng-container>
        <ng-container matColumnDef="TeacherName">
          <th mat-header-cell *matHeaderCellDef> Teacher Name</th>
          <td mat-cell *matCellDef="let element">{{element.TeacherName}}</td>
        </ng-container>
        <ng-container matColumnDef="Period">
          <th mat-header-cell *matHeaderCellDef> Per </th>
          <td mat-cell *matCellDef="let element">{{element.Period}}</td>
        </ng-container>
        <ng-container matColumnDef="TermCode">
          <th mat-header-cell *matHeaderCellDef> Term </th>
          <td mat-cell *matCellDef="let element">{{element.TermCode}}</td>
        </ng-container>
        <ng-container matColumnDef="DepartmentCode">
          <th mat-header-cell *matHeaderCellDef> Dept </th>
          <td mat-cell *matCellDef="let element">{{element.DepartmentCode}}</td>
        </ng-container>
        <ng-container matColumnDef="SubjectCode">
          <th mat-header-cell *matHeaderCellDef> Subject </th>
          <td mat-cell *matCellDef="let element">{{element.SubjectCode}}</td>
        </ng-container>
        <ng-container matColumnDef="Section">
          <th mat-header-cell *matHeaderCellDef>Sec</th>
          <td mat-cell *matCellDef="let element">{{element.Section}}</td>
        </ng-container>
        <ng-container matColumnDef="RoomNumber">
          <th mat-header-cell *matHeaderCellDef> Room</th>
          <td mat-cell *matCellDef="let element">{{element.RoomNumber}}</td>
        </ng-container>
        <ng-container matColumnDef="DaysGroupDescription">
          <th mat-header-cell *matHeaderCellDef> Days</th>
          <td mat-cell *matCellDef="let element">{{element.DaysGroupDescription}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="gridColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: gridColumns;"></tr>
      </table>
    </div>

  </mat-dialog-content>
  <!-- Footer -->
  <mat-dialog-actions>
    <!-- Footer -->
    <div class="flex-footer-left" style="align-items: center; width: 30%">
    </div>
    <div class="flex-footer-right" style="align-items: center; width: 70%">
      <!-- ERROR PROMPT -->
      <error-prompt [errorList]="errors"></error-prompt>
      <!-- CANCEL -->
      <tyl-button style="float:right; color: black;" image="post.png" label="Export" (clickEvent)="exportCLick = true; runClick()">
      </tyl-button>
      <tyl-button style="float:right; color: black;" image="save.png" label="Run" (clickEvent)="exportCLick = false; runClick()">
      </tyl-button>
      <tyl-button style="float:right; color: black;" image="cancel.png" label="Cancel"
        (clickEvent)="cancelShowReportParameters()"></tyl-button>
    </div>
  </mat-dialog-actions>
